// extracted by mini-css-extract-plugin
module.exports =  {"option":"option-HcOSE","label":"label-IR8xX","icon":"icon-I_g2q"};